// extracted by mini-css-extract-plugin
export default {"AdminMarkers":"admin-markers_AdminMarkers__LkOVp","SearchBlock":"admin-markers_SearchBlock__QxS+G"};